module.exports = __webpack_public_path__ + "static/media/categories.fe9d1e3d.svg";